export * from 'catalogs/actions/catalogs_actions';



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/actions/index.js